module.exports = __webpack_public_path__ + "static/media/website-12.cffac9af.png";